import baccaratArt from '@/assets/home-menu/baccarat.webp';
import betzoneArt from '@/assets/home-menu/betzone.webp';
import crashArt from '@/assets/home-menu/crash.webp';
import lastMinuteArt from '@/assets/home-menu/last-minute.webp';
import liveArt from '@/assets/home-menu/live.webp';
import liveCasinoArt from '@/assets/home-menu/live-casino.webp';
import promosArt from '@/assets/home-menu/promos.webp';
import slotsArt from '@/assets/home-menu/slots.webp';
import sportsArt from '@/assets/home-menu/sports.webp';
import tableGamesArt from '@/assets/home-menu/table-games.webp';
import topEventsArt from '@/assets/home-menu/top-events.webp';
import topLeaguesArt from '@/assets/home-menu/top-leagues.webp';

export interface HomeMenuItem {
  id: string;
  /** Accessible name (and single-line label when `labelLines` is omitted). */
  label: string;
  /** Legacy WebsiteTranslates key for `t()`. */
  translateKey: string;
  /** Two-line Figma labels; when set, replaces the single-line `label` visually. */
  labelLines?: readonly [string, string];
  image: string;
  /** Object-position / size overrides matching Figma crop for each asset. */
  imageClassName: string;
  to: string;
}

/** Figma HomeMainMenu / Mobile item order and destinations. */
export const HOME_MENU_ITEMS: readonly HomeMenuItem[] = [
  {
    id: 'sports',
    label: 'Sports',
    translateKey: 'Sports',
    image: sportsArt,
    imageClassName: 'inset-0 size-full object-contain',
    to: '/sports',
  },
  {
    id: 'slots',
    label: 'Slots',
    translateKey: 'Slots',
    image: slotsArt,
    imageClassName: 'left-[-9.31%] top-[-7.19%] size-[118.63%] max-w-none',
    to: '/casino',
  },
  {
    id: 'live-casino',
    label: 'Live Casino',
    translateKey: 'LiveCasino',
    labelLines: ['Live', 'Casino'],
    image: liveCasinoArt,
    imageClassName: 'left-[-7.34%] top-[-7.34%] size-[114.68%] max-w-none',
    to: '/livecasino',
  },
  {
    id: 'baccarat',
    label: 'Baccarat',
    translateKey: 'Baccarat',
    image: baccaratArt,
    imageClassName: 'left-[-8.44%] top-[-8.44%] size-[116.88%] max-w-none',
    to: '/livecasino',
  },
  {
    id: 'live',
    label: 'Live',
    translateKey: 'LiveBetting',
    image: liveArt,
    imageClassName: 'left-[-8.5%] top-[-8.5%] size-[117.01%] max-w-none',
    to: '/live',
  },
  {
    id: 'table-games',
    label: 'Table Games',
    translateKey: 'TableGames',
    labelLines: ['Table', 'Games'],
    image: tableGamesArt,
    imageClassName: 'left-[-10.76%] top-[-8.69%] size-[121.52%] max-w-none',
    to: '/casino',
  },
  {
    id: 'top-events',
    label: 'Top Events',
    translateKey: 'Topevents',
    labelLines: ['Top', 'Events'],
    image: topEventsArt,
    imageClassName: 'left-[9.08%] top-[1.66%] h-[96.67%] w-[79.12%] max-w-none',
    to: '/sports/football/topevents',
  },
  {
    id: 'top-leagues',
    label: 'Top Leagues',
    translateKey: 'Topleagues',
    labelLines: ['Top', 'Leagues'],
    image: topLeaguesArt,
    imageClassName: 'left-[11.05%] top-[2.9%] h-[94.19%] w-[77.91%] max-w-none',
    to: '/sports',
  },
  {
    id: 'last-minute',
    label: 'Last Minute',
    translateKey: 'Lastminute',
    labelLines: ['Last', 'Minute'],
    image: lastMinuteArt,
    imageClassName: 'left-[12.04%] top-0 h-full w-[75.91%] max-w-none',
    to: '/sports/football/lastminute',
  },
  {
    id: 'betzone',
    label: 'BetZone',
    translateKey: 'Betzone',
    image: betzoneArt,
    imageClassName: 'left-0 top-[10.43%] h-[79.14%] w-full max-w-none',
    to: '/betzone',
  },
  {
    id: 'crash',
    label: 'Crash',
    translateKey: 'Crash',
    image: crashArt,
    imageClassName: 'left-[-14.23%] top-[-15.88%] size-[128.46%] max-w-none',
    to: '/casino',
  },
  {
    id: 'promos',
    label: 'Promos',
    translateKey: 'Promotions',
    image: promosArt,
    imageClassName: 'left-[-15.04%] top-[-17%] size-[130.08%] max-w-none',
    to: '/promotions',
  },
];
